// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input {
  border: 0;
  margin: 0;
  padding: 0;
}

.input-title {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  color: var(--sebrae-gray);
}

.input-default {
  width: 100%;
  height: 40px;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  border: 1px solid var(--sebrae-light-gray5);
}`, "",{"version":3,"sources":["webpack://./src/components/input/index.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,SAAA;EACA,UAAA;AACF;;AACA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AAEF","sourcesContent":["input {\n  border: 0;\n  margin: 0;\n  padding: 0;\n}\n.input-title {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n  color: var(--sebrae-gray);\n}\n\n.input-default {\n  width: 100%;\n  height: 40px;\n  margin-top: 8px;\n  padding: 8px 12px;\n  border-radius: 4px;\n  border: 1px solid var(--sebrae-light-gray5);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
